import { Box, LinearProgress } from '@mui/material';
import React from 'react';
import { HEADER_HEIGHT } from '../../../../../corelogic/domain/constants/headerHeight.constant';

interface LoadingBarProps {
  isLoading: boolean;
  position?: 'absolute' | 'fixed' | 'relative' | 'static' | 'sticky';
  height?: number;
  margin?: string | number;
  attachToHeader?: boolean;
}

const LoadingBar: React.FC<LoadingBarProps> = ({
  isLoading,
  position = 'absolute',
  height = 4,
  margin = 0,
  attachToHeader = true,
}) => {
  if (!isLoading) return null;

  return (
    <Box
      sx={{
        margin,
        position: attachToHeader ? 'fixed' : position,
        top:
          position === 'relative'
            ? undefined
            : attachToHeader
              ? `calc(${HEADER_HEIGHT} - ${height}px)`
              : 0,
        left: position === 'relative' ? undefined : 0,
        right: position === 'relative' ? undefined : 0,
        zIndex: 9999,
        visibility: 'visible',
        opacity: 1,
      }}
    >
      <LinearProgress
        sx={{
          height,
          backgroundColor: 'rgba(255,255,255,0.1)',
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#cc0000',
            animationDuration: '4s',
          },
        }}
      />
    </Box>
  );
};

export default LoadingBar;
